
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, Operation, PageOptions } from 'cw-backend';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class OperationListProvider implements Resolve<any> {
    operation: Operation[];
    operationEdit: Operation;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();

        if (this.state?.currentPage && state.url.includes(this.state?.path)) {
            this.currentPage = this.state?.currentPage;
        }
        this.operationEdit = this.state?.currentOperation;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'started';
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    get(id: number): Observable<any> {
        if (!id) {
            return null;
        }
        return this.gw.get('operation/wAll/:id', { id: id });
    }

    get currentOperation(): Operation {
        return this.operationEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('operation/').subscribe((res: HttpResponse<any>) => {
                this.operation = res.body;
                resolve(res);
            }, reject);
        });

    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('operation/search', pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.operation, res.body.content) && res.body.content.length > 0) {
                    this.operation = res.body.content;
                    this.onDataChanged.next(this.operation);
                }
                else {
                    this.operation = res.body.content;
                };
                resolve(res);
            }, reject);
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }

    getTypeList(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('operation/operationType/simpleList')
                .subscribe((res: HttpResponse<any>) => {
                    resolve(res);
                }, reject);
        });
    }

    getScheduleFree(scheduleFilterTO): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('operation/findBySchedule', scheduleFilterTO).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                }, error(err) {
                    reject(err);
                },
            });
        });

    }
    deleteScheduleFree(selectedItems): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.delete('operation/deleteScheduleFree', selectedItems).subscribe({
                next: (res: HttpResponse<any>) => {
                    resolve(res);
                }, error(err) {
                    reject(err);
                },
            });
        });

    }
}

